import { createSelector } from "@reduxjs/toolkit";

export const getSomClassifier = (state) => state.books.somClassifier;
export const getSomMatchTypes = (state) => state.books.matchTypes;
export const getSomStrMatchTypes = (state) => state.books.strMatchTypes;
export const getSomChars = (state) => state.books.charsBook;
export const getSomCharsEnum = (state) => state.books.charsEnumBook;
export const getSomStatus = (state) => state.books.somStatus;
export const getFilterTypes = (state) => state.books.filterTypes;

export const getSomCharById = createSelector([getSomChars], (chars) => {
	return chars.reduce((acc, char) => {
		return {
			...acc,
			[char.id]: char,
		};
	}, {});
});

export const getSsrCalcsBook = (state) => state.books.ssrCalcsBook;
export const getSsrCalcsTypes = (state) => state.books.ssrCalcsTypes;

export const getPriceZones = (state) => state.books.priceZones;
export const getCities = (state) => state.books.cities;
export const getNrspVers = (state) => state.books.nrspVers;
export const getNorthTerrs = (state) => state.books.northTerrs;
export const getProjectObjTypes = (state) => state.books.projectObjTypes;
export const getProjectWorkTypes = (state) => state.books.projectWorkTypes;

export const getFilterTypeById = createSelector([getFilterTypes], (filterTypes) => {
	return filterTypes.reduce(
		(acc, type) => ({
			...acc,
			[type.id]: type,
		}),
		{}
	);
});

export const getXmlShemas = (state) => state.books.xmlShemas;
export const getUnits = (state) => state.books.units;
export const getSomUnits = createSelector([getUnits], (units) => {
	return units.filter(({ not_som_unit }) => not_som_unit !== true);
});
